export default __webpack_public_path__ + "static/media/weez-world.73332c79.png";